import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import DiwaliPopup from './components/DiwaliPopup';
import Footer from './components/Footer';
import FloatingContact from './components/FloatingContact';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Tariff from './pages/Tariff';
import Contact from './pages/Contact';
import Calculate from './pages/Calculate';
import ConfirmSuccess from './pages/ConfirmSuccess';
import ChennaiToMadurai from './pages/ChennaiToMadurai';
import MaduraiToChennai from './pages/MaduraiToChennai';
import CoimbatoreToOoty from './pages/CoimbatoreToOoty';
import RouteLandingPage from './pages/RouteLandingPage';
import HubLandingPage from './pages/HubLandingPage';
import AllTaxiRoutes from './pages/AllTaxiRoutes';
import SinganallurTaxi from './pages/SinganallurTaxi';
import DriverPrivacyPolicy from './pages/DriverPrivacyPolicy';
import DriverTerms from './pages/DriverTerms';
import DriverDataDeletion from './pages/DriverDataDeletion';
import CustomerAccountDeletion from './pages/CustomerAccountDeletion';
import CustomerPolicyPage from './pages/CustomerPolicyPage';
import DriverSupport from './pages/DriverSupport';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import { ROUTE_LANDING_PAGES } from './data/routeLanding';
import { FEATURED_ROUTE_LANDING_PAGES } from './data/featuredRoutes';
import { LOCAL_CORRIDOR_PAGES } from './data/localCorridorPages';
import LocalCorridorPage from './pages/LocalCorridorPage';
import { HUB_LANDING_PAGES } from './data/hubLanding';
import { DISTRICT_LANDING_PAGES } from './data/districtPages';
import DistrictLandingPage from './pages/DistrictLandingPage';
import { CUSTOMER_POLICY_ROUTES } from './data/customerPolicies';
import './styles/App.css';
import './styles/responsive.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './styles/typography.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const resetScroll = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
    };

    resetScroll();
    const t = setTimeout(resetScroll, 120);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <DiwaliPopup />
      <FloatingContact />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/tariff" element={<Tariff />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/calculate" element={<Calculate />} />
        <Route path="/confirm-success" element={<ConfirmSuccess />} />
        <Route path="/chennai-to-madurai-taxi" element={<ChennaiToMadurai />} />
        <Route path="/madurai-to-chennai-taxi" element={<MaduraiToChennai />} />
        <Route path="/coimbatore-to-ooty" element={<CoimbatoreToOoty />} />
        <Route path="/taxi-routes" element={<AllTaxiRoutes />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        {ROUTE_LANDING_PAGES.map((page) => (
          <Route
            key={page.slug}
            path={page.slug}
            element={<RouteLandingPage page={page} />}
          />
        ))}
        {FEATURED_ROUTE_LANDING_PAGES.filter((page) => page.slug !== '/coimbatore-to-ooty').map((page) => (
          <Route
            key={page.slug}
            path={page.slug}
            element={<RouteLandingPage page={page} />}
          />
        ))}
        {LOCAL_CORRIDOR_PAGES.map((page) => (
          <Route
            key={page.slug}
            path={page.slug}
            element={<LocalCorridorPage page={page} />}
          />
        ))}
        {HUB_LANDING_PAGES.map((page) => (
          <Route
            key={page.slug}
            path={page.slug}
            element={<HubLandingPage page={page} />}
          />
        ))}
        {DISTRICT_LANDING_PAGES.map((page) => (
          <Route
            key={page.slug}
            path={page.slug}
            element={<DistrictLandingPage page={page} />}
          />
        ))}
        <Route path="/singanallur-taxi" element={<SinganallurTaxi />} />
        <Route path="/driver-privacy-policy" element={<DriverPrivacyPolicy />} />
        <Route path="/driver-terms" element={<DriverTerms />} />
        <Route path="/driver-data-deletion" element={<DriverDataDeletion />} />
        <Route path="/customer-account-deletion" element={<CustomerAccountDeletion />} />
        <Route
          path={CUSTOMER_POLICY_ROUTES.terms}
          element={<CustomerPolicyPage policyKey="terms" />}
        />
        <Route
          path={CUSTOMER_POLICY_ROUTES.privacy}
          element={<CustomerPolicyPage policyKey="privacy" />}
        />
        <Route
          path={CUSTOMER_POLICY_ROUTES.booking}
          element={<CustomerPolicyPage policyKey="booking" />}
        />
        <Route
          path={CUSTOMER_POLICY_ROUTES.cancellation}
          element={<CustomerPolicyPage policyKey="cancellation" />}
        />
        <Route
          path={CUSTOMER_POLICY_ROUTES.fare}
          element={<CustomerPolicyPage policyKey="fare" />}
        />
        <Route path="/driver-support" element={<DriverSupport />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
